/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Claim_Vekn_TitleInputs */



/**
* | output |
* | --- |
* | "Claim VEKN ID" |
*
* @param {Profile_Claim_Vekn_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const profile_claim_vekn_title = /** @type {((inputs?: Profile_Claim_Vekn_TitleInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Claim_Vekn_TitleInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Revendiquer un VEKN ID")
	if (locale === "es") return /** @type {LocalizedString} */ ("Reclamar ID VEKN")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Reivindicar VEKN ID")
	if (locale === "it") return /** @type {LocalizedString} */ ("Reclama VEKN ID")
	return /** @type {LocalizedString} */ ("Claim VEKN ID")
});